import * as React from 'react';
import { Preview } from './components/preview';
import { MessageBox } from '../MessageBox';
import { useController } from './folder-preview-management.controller';
import FormatManagement from '../FormatManagement';
import { FolderPreviewManagementProps } from './folder-preview-management.types';

export const FolderPreviewManagement: React.FC<FolderPreviewManagementProps> = (props) => {
  const { previewProps, close, formatLoaderProps } = props;

  const {
    isAllowedToSubmitFormatOrFolderLoader,
    handleFormatDelete,
    formats,
    getAndSetFormats,
    resetFormats,
    handleFolderDelete,
    handleFolderCreate,
    selectedFolder,
    selectedFormat,
    folders,
    getAndSetFolders,
    handleFolderSelect,
    closeFolderPicker,
    showErrorMessage,
    messageProps,
    closeMessage,
    openFolderPicker,
    handleSubmit,
    folderPickerOpened,
  } = useController(props);
  
  return (
    <>
      <MessageBox
        hideMessageBox={closeMessage}
        {...messageProps}
      />
      <Preview 
        close={close}
        selectedFolder={selectedFolder}
        title={previewProps.title}
        submitBtnProps={previewProps.submitBtnProps}
        showErrorMessage={showErrorMessage}
        onSubmit={handleSubmit}
        onOpenFolderPicker={openFolderPicker}
        showNameField={previewProps.showNameField}
      />
      {folderPickerOpened && (
        <FormatManagement 
          selectedFolder={selectedFolder}
          selectedFormat={selectedFormat}
          title={formatLoaderProps.title}
          submitBtnProps={formatLoaderProps.submitBtnProps}
          deleteFormatBtnProps={formatLoaderProps.deleteFormatBtnProps}
          close={closeFolderPicker}
          folders={folders}
          formats={formats}
          isAllowedToSubmit={isAllowedToSubmitFormatOrFolderLoader}
          getFormats={getAndSetFormats}
          resetFormats={resetFormats}
          getFolders={getAndSetFolders}
          onSubmit={handleFolderSelect}
          onFormatDelete={handleFormatDelete}
          onFolderDelete={handleFolderDelete}
          onFolderCreate={handleFolderCreate}
        />
      )}
    </>
  );
};